<div class="row">
  <div class="col-lg-12 col-sm-12 col-md-12 header-center">
    <table>
      <tr>
        <td>
          <!--<img src="assets/images/panadol-logo.png" class="header-logo" />-->
        </td>
        <td class="header-title">
          <strong>References:</strong>
        </td>
      </tr>
    </table>
  </div>


</div>

<div class="row bodyScroll">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <table style="width:100%;margin-top:20px;max-width:100%;" class="reference-table">
      <tr>
        <td>1.</td>
        <td>Bendtsen L, Evers S, Linde M, Mitsikostas D, Sandrini G, Schoenen J. Eur J Neurol. 17 1318-25 (2010). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/20482606')">
            https://www.ncbi.nlm.nih.gov/pubmed/20482606</a>.</td>
      </tr>
      <tr>
        <td>2.</td>
        <td>Sarchielli P, Granella F, Prudenzano M et al. J Headache Pain. 13(Suppl 2), S31-S70 (2012). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/22581120')">
            https://www.ncbi.nlm.nih.gov/pubmed/22581120</a>.</td>
      </tr>
      <tr>
        <td>3.</td>
        <td>Becker W, Findlay T, Moga C, Et Al. Can Fam Physician. 61(8), 670-9 (2015). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4541429/')">
            https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4541429/</a>.</td>
      </tr>
      <tr>
        <td>4.</td>
        <td>Vukovi Cvetkovi V, Kes Vb, Seri V et al. Acta Clin Croat. 51(3), 323-78 (2012). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/23330402')">
            https://www.ncbi.nlm.nih.gov/pubmed/23330402/</a>.</td>
      </tr>
      <tr>
        <td>5.</td>
        <td>Bendtsen L, Birk S, Kasch H et al. J Headache Pain. 13(Suppl 1), 1-29 (2012). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/22270537')">
            https://www.ncbi.nlm.nih.gov/pubmed/22270537</a>.</td>
      </tr>
      <tr>
        <td>6.</td>
        <td>Federal Ministry of Health for Nigeria. Standard treatment guidelines. <a
            (click)="open(disclaimer, 'http://www.health.gov.ng/doc/FMOH%20-%20Nigeria%20Standard%20Treatment%20Guidelines%202nd%20Edition%20(2016).pdf')">
            http://www.health.gov.ng/doc/FMOH%20-%20Nigeria%20Standard%20Treatment%20Guidelines%202nd%20Edition%20(2016).pdf</a>
          (Access date 11 Dec 2018).</td>
      </tr>
      <tr>
        <td>7.</td>
        <td>
          British Association for the Study of Headache. Guidelines for all healthcare professionals in the diagnosis
          and management of migraine, tension-type, cluster and medication-overuse headache. <a
            (click)="open(disclaimer, 'http://www.nhsgrampian.org/neurology/files/2010_BASH_Guidelines.pdf')">
            http://www.nhsgrampian.org/neurology/files/2010_BASH_Guidelines.pdf</a> (Access date 21/06/2017).
        </td>
      </tr>
      <tr>
        <td>8.</td>
        <td>Scottish Intercollegiate Guidelines Network. Diagnosis and management of headache in adults. A national
          clinical guideline. <a (click)="open(disclaimer, 'http://www.sign.ac.uk/assets/sign107.pdf')">
            http://www.sign.ac.uk/assets/sign107.pdf</a></td>
      </tr>
      <tr>
        <td>9.</td>
        <td>National Institute for Health and Care Excellence. Headaches in over 12s: diagnosis and management. <a
            (click)="open(disclaimer, 'https://www.nice.org.uk/guidance/cg150/chapter/Recommendations#management-2')">
            https://www.nice.org.uk/guidance/cg150/chapter/Recommendations#management-2</a> (Access date 17 Dec 2018).
        </td>
      </tr>
      <tr>
        <td>10.</td>
        <td>Beithon J, Gallenberg M, Johnson K et al. Institute for Clinical Systems Improvement. Diagnosis and
          treatment of headache. <a (click)="open(disclaimer, 'http://bit.ly/Headache0113')">
            http://bit.ly/Headache0113</a> (Access date 21 Aug 2017).</td>
      </tr>
      <tr>
        <td>11.</td>
        <td>Haag G, Diener H, May A et al. J Headache Pain. 12 201-17 (2011). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/21181425')">
            https://www.ncbi.nlm.nih.gov/pubmed/21181425</a>.</td>
      </tr>
      <tr>
        <td>12.</td>
        <td>
          Food Medicine and Healthcare Administration and Control Authority of Ethiopia. Standard treatment guidelines
          for primary hospital. Good prescribing & dispensing practices for better health outcomes. <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/documents/s21694en/s21694en.pdf')">
            http://apps.who.int/medicinedocs/documents/s21694en/s21694en.pdf</a> (Access date 26 June 2018).
        </td>
      </tr>
      <tr>
        <td>13.</td>
        <td>Evers S, Afra J, Frese A et al. Eur J Neurol. 16 968-81 (2009). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/19708964')">
            https://www.ncbi.nlm.nih.gov/pubmed/19708964</a>.</td>
      </tr>
      <tr>
        <td>14.</td>
        <td>Lanteri-Minet M, Valade D, Geraud G, Lucas C, Donnet A. J Headache Pain. 15(1), 2 (2014). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3905961/')">https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3905961/</a>.
        </td>
      </tr>
      <tr>
        <td>15.</td>
        <td>Migraine Association of Ireland. Guide to migraine medications. <a
            (click)="open(disclaimer, 'http://www.migraine.ie/wp-content/uploads/2016/08/Guide-to-Migraine-Medications.pdf')">
            http://www.migraine.ie/wp-content/uploads/2016/08/Guide-to-Migraine-Medications.pdf</a> (Access date 26 June
          2018).</td>
      </tr>
      <tr>
        <td>16.</td>
        <td>National Department of Health South Africa. Standard treatment guidelines and essential medicines list for
          South Africa. <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/documents/s23014en/s23014en.pdf')">
            http://apps.who.int/medicinedocs/documents/s23014en/s23014en.pdf</a> (Access date 11 Dec 2018).</td>
      </tr>
      <tr>
        <td>17.</td>
        <td>Marmura M, Silberstein S, Schwedt T. Headache. 55(1), 3-20 (2015). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/25600718')">
            https://www.ncbi.nlm.nih.gov/pubmed/25600718</a>.</td>
      </tr>
      <tr>
        <td>18.</td>
        <td>Edliz. 6th Essential Medicines List and Standard Treatment Guidelines for Zimbabwe. <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/documents/s21753en/s21753en.pdf')">
            http://apps.who.int/medicinedocs/documents/s21753en/s21753en.pdf</a> (Access date 4 Jul 2018).</td>
      </tr>
      <tr>
        <td>19.</td>
        <td>Bordini Ca, Roesler C, Carvalho Dde S et al. Arq Neuropsiquiatr. 74(3), 262-71 (2016). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/27050859')">
            https://www.ncbi.nlm.nih.gov/pubmed/27050859</a>.</td>
      </tr>
      <tr>
        <td>20.</td>
        <td>Worthington I, Pringsheim T, Gawel M, Et Al. Can J Neurol Sci. 40(5 Suppl 3), S1-S180 (2013). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/23968886')">
            https://www.ncbi.nlm.nih.gov/pubmed/23968886</a>.</td>
      </tr>
      <tr>
        <td>21.</td>
        <td>Toward Optimized Practice. Primary care management of headache in adults. Clinical Practice Guideline. <a
            (click)="open(disclaimer, 'http://www.topalbertadoctors.org/download/597/Guideline+for+Primary+Care+Management+of+Headache+in+Adults.pdf')">
            http://www.topalbertadoctors.org/download/597/Guideline+for+Primary+Care+Management+of+Headache+in+Adults.pdf</a>
          (Access date 26 June 2018).</td>
      </tr>
      <tr>
        <td>22.</td>
        <td>National Institute for Health and Care Excellence (Nice). Headaches in over 12s: diagnosis and management.
          Clinical guideline [CG150]. <a
            (click)="open(disclaimer, 'https://www.nice.org.uk/guidance/CG150/chapter/Recommendations')">
            https://www.nice.org.uk/guidance/CG150/chapter/Recommendations</a> (Access date 10 Jan 2018).</td>
      </tr>
      <tr>
        <td>23.</td>
        <td>Vukovic Cvetkovic V, Kes Vb, Seric V et al. Acta Clin Croat. 51(3), 323-78 (2012). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/23330402')">https://www.ncbi.nlm.nih.gov/pubmed/23330402</a>.
        </td>
      </tr>
      <tr>
        <td>24.</td>
        <td>Ministry of Health Republic of Ghana. Chapter 10: Disorders of the central nervous system. Headache. <a
            (click)="open(disclaimer, 'http://www.moh.gov.gh/wp-content/uploads/2016/02/Standard-Treatment-Guideline-2010.pdf')">
            http://www.moh.gov.gh/wp-content/uploads/2016/02/Standard-Treatment-Guideline-2010.pdf</a> (Access date 26
          June 2018).</td>
      </tr>
      <tr>
        <td>25.</td>
        <td>Scottish Intercollegiate Guidelines Network. Diagnosis and management of headache in adults. A national
          clinical guideline. <a (click)="open(disclaimer, 'http://www.sign.ac.uk/assets/sign107.pdf')">
            http://www.sign.ac.uk/assets/sign107.pdf</a>.</td>
      </tr>
      <tr>
        <td>26.</td>
        <td>Islamic Republic of Afghanistan, Ministry of Public Health, General Directorate of Pharmaceutical Affairs.
          National standard treatment guidelines for the primary level. <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/documents/s21744en/s21744en.pdf')">
            http://apps.who.int/medicinedocs/documents/s21744en/s21744en.pdf </a> (Access date 13 Jul 2018).</td>
      </tr>
      <tr>
        <td>27.</td>
        <td>Ministry of Health for the Republic of Ghana. Standard Treatment Guidelines. <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/en/d/Js18015en/')">
            http://apps.who.int/medicinedocs/en/d/Js18015en/</a> (Access date 13 Jul 2018).</td>
      </tr>
      <tr>
        <td>28.</td>
        <td>
          Republic of Kenya. Clinical Management and Referral Guidelines – Volume III: Clinical Guidelines for
          Management and Referral of Common Conditions at Levels 4–6:Hospitals <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/en/m/abstract/Js21000en/')">
            http://apps.who.int/medicinedocs/en/m/abstract/Js21000en/</a> (Access date 13 Jul 2018).
        </td>
      </tr>
      <tr>
        <td>29.</td>
        <td>National Department of Health SA. Standard treatment guidelines and essential medicines list for South
          Africa. Hospital level adults. <a
            (click)="open(disclaimer, 'http://www.kznhealth.gov.za/pharmacy/hospitallevel_adult2015.pdf')">
            http://www.kznhealth.gov.za/pharmacy/hospitallevel_adult2015.pdf</a> (Access date 13 Jul 2018).</td>
      </tr>
      <tr>
        <td>30.</td>
        <td>National Institute for Health and Care Excellence (Nice). Dysmenorrhea. <a
            (click)="open(disclaimer, 'https://cks.nice.org.uk/dysmenorrhoea')">https://cks.nice.org.uk/dysmenorrhoea</a>
          (Access date 24 Nov 2017).</td>
      </tr>
      <tr>
        <td>31.</td>
        <td>Burnett M, Lemyre M. J Obstet Gynaecol Can. 39(7), 585-95 (2017). <a
            (click)="open(disclaimer, 'https://www.sciencedirect.com/science/article/pii/S1701216316399303')">https://www.sciencedirect.com/science/article/pii/S1701216316399303</a>.
        </td>
      </tr>
      <tr>
        <td>32.</td>
        <td>Medsask. Dysmenorrhea. <a
            (click)="open(disclaimer, 'https://medsask.usask.ca/professional/guidelines/dysmenorrhea.php')">
            https://medsask.usask.ca/professional/guidelines/dysmenorrhea.php</a> (Access date 28 Feb 2018).</td>
      </tr>
      <tr>
        <td>33.</td>
        <td>American Society of Aerospace Medicine Specialists, Aerospace Medical Association. Clinical Practice
          Guideline for dysmenorrhea. <a
            (click)="open(disclaimer, 'http://www.asams.org/guidelines/Completed/NEW%20Dysmenorrhea.htm ')">
            http://www.asams.org/guidelines/Completed/NEW%20Dysmenorrhea.htm</a> (Access date 24 Nov 2017).</td>
      </tr>
      <tr>
        <td>34.</td>
        <td>Registered Nurses' Association of Ontario. Clinical best practice guidelines: assessment and management of
          pain. <a (click)="open(disclaimer, 'http://rnao.ca/bpg/guidelines/assessment-and-management-pain')">
            http://rnao.ca/bpg/guidelines/assessment-and-management-pain</a> (Access date 21 Dec 2017).</td>
      </tr>
      <tr>
        <td>35.</td>
        <td>Republic of Rwanda Ministry of Health. Pain management guidelines. <a
            (click)="open(disclaimer, 'http://www.moh.gov.rw/fileadmin/templates/Norms/Pain-Management-Guidelines-15-11-2012-.pdf')">
            http://www.moh.gov.rw/fileadmin/templates/Norms/Pain-Management-Guidelines-15-11-2012-.pdf</a> (Access date
          4 Jul 2018).</td>
      </tr>
      <tr>
        <td>36.</td>
        <td>Hooten M, Thorson D, Bianco J et al. Pain: Assessment, Non-Opioid Treatment Approaches and Opioid
          Management. <a (click)="open(disclaimer, 'https://www.icsi.org/_asset/f8rj09/Pain.pdf')">
            https://www.icsi.org/_asset/f8rj09/Pain.pdf</a> (Access date 16 Dec 2018).</td>
      </tr>
      <tr>
        <td>37.</td>
        <td>
          Agency for Clinical Innovation (Aci). Management of people with acute low back pain. <a
            (click)="open(disclaimer, 'https://www.aci.health.nsw.gov.au/__data/assets/pdf_file/0007/336688/acute-low-back-pain-moc.pdf')">
            https://www.aci.health.nsw.gov.au/__data/assets/pdf_file/0007/336688/acute-low-back-pain-moc.pdf
          </a> (Access date 8 Nov 2017).
        </td>
      </tr>
      <tr>
        <td>38.</td>
        <td>Institute of Health Economics, Toward Optimized Practice. Evidence-informed primary care management of low
          back pain. <a (click)="open(disclaimer, 'http://www.topalbertadoctors.org/cpgs/885801')">
            http://www.topalbertadoctors.org/cpgs/885801</a> (Access date 27 Nov 2018).</td>
      </tr>
      <tr>
        <td>39.</td>
        <td>Poitras P, Rossignol M, Dionne C et al. BMC Musculoskelet Dis. 9 54 (2008). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/18426590')">
            https://www.ncbi.nlm.nih.gov/pubmed/18426590</a>.</td>
      </tr>
      <tr>
        <td>40.</td>
        <td>Krismer M, Van Tulder M, Low Back Pain Group of the Bone and Joint Health Strategies for Europe Project.
          Best Pract Res Clin Rheumatol. 21(1), 77-91 (2007). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/17350545')">
            https://www.ncbi.nlm.nih.gov/pubmed/17350545</a>.</td>
      </tr>
      <tr>
        <td>41.</td>
        <td>Van Tulder M, Becker A, Bekkering T et al. Eur Spine J. 15(Suppl 2), S169-S91 (2006). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/16550447')">https://www.ncbi.nlm.nih.gov/pubmed/16550447</a>.
        </td>
      </tr>
      <tr>
        <td>42.</td>
        <td>Negrini S, Giovannoni S, Minozzi S et al. Eura Medicophys. 42(2), 151-70 (2006). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/16767064')">
            https://www.ncbi.nlm.nih.gov/pubmed/16767064</a>.</td>
      </tr>
      <tr>
        <td>43.</td>
        <td>Malaysian Association for the Study of Pain, Spine Society Malaysia. The Malaysian Low Back Pain Management
          Guidelines. <a (click)="open(disclaimer, 'http://www.masp.org.my/index.cfm?&menuid=23')">
            http://www.masp.org.my/index.cfm?&menuid=23</a> (Access date 8 Nov 2017).</td>
      </tr>
      <tr>
        <td>44.</td>
        <td>National Health Committee. Low back pain: A pathway to prioritisation. <a
            (click)="open(disclaimer, 'https://www.health.govt.nz/system/files/documents/publications/nhc-lbp-pathway-to-prioritisation.pdf')">
            https://www.health.govt.nz/system/files/documents/publications/nhc-lbp-pathway-to-prioritisation.pdf</a>
          (Access date 8 Nov 2017).</td>
      </tr>
      <tr>
        <td>45.</td>
        <td>Accident Compensation Corporation (Acc). New Zealand acute low back pain guide. <a
            (click)="open(disclaimer, 'https://www.healthnavigator.org.nz/media/1006/nz-acute-low-back-pain-guide-acc.pdf')">
            https://www.healthnavigator.org.nz/media/1006/nz-acute-low-back-pain-guide-acc.pdf</a> (Access date 8 Nov
          2017).</td>
      </tr>
      <tr>
        <td>46.</td>
        <td>The Norwegian Back Pain Network - the Communication Unit. Acute low back pain. Interdisciplinary clinical
          guidelines. <a (click)="open(disclaimer, 'http://www.sohs.com.sg/pdf/Norway_Acute_Low_Back.pdf')">
            http://www.sohs.com.sg/pdf/Norway_Acute_Low_Back.pdf</a> (Access date 8 Nov 2017).</td>
      </tr>
      <tr>
        <td>47.</td>
        <td>Philippine Academy of Rehabilitation Medicine (Parm). Clinical practice guidelines on the diagnosis and
          management of low back pain (updated 2017). <a
            (click)="open(disclaimer, 'http://parm.com.ph/wp-content/uploads/2018/02/PARM-LBP-CPG-2nd-Edition-2017.pdf')">
            http://parm.com.ph/wp-content/uploads/2018/02/PARM-LBP-CPG-2nd-Edition-2017.pdf</a> (Access date 28 Nov
          2018).</td>
      </tr>
      <tr>
        <td>48.</td>
        <td>Savigny P, Kuntze S, Watson P et al. Low back pain: early management of persistent non-specific low back
          pain. Full guideline <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmedhealth/PMH0005442/pdf/PubMedHealth_PMH0005442.pdf')">
            https://www.ncbi.nlm.nih.gov/pubmedhealth/PMH0005442/pdf/PubMedHealth_PMH0005442.pdf</a> (Access date 8 Nov
          2017).</td>
      </tr>
      <tr>
        <td>49.</td>
        <td>Royal College of General Practitioners. Clinical Guidelines for the Management of Acute Low Back Pain. <a
            (click)="open(disclaimer, 'http://www.chiro.org/LINKS/GUIDELINES/FULL/Royal_College/index.html')">http://www.chiro.org/LINKS/GUIDELINES/FULL/Royal_College/index.html</a>
          (Access date 28 Nov 2018).</td>
      </tr>
      <tr>
        <td>50.</td>
        <td>Chou R, Qaseem A, Snow V et al. Ann Intern Med. 147(7), 478-91 (2007). <a
            (click)="open(disclaimer, 'http://annals.org/aim/fullarticle/736814/diagnosis-treatment-low-back-pain-joint-clinical-practice-guideline-from')">http://annals.org/aim/fullarticle/736814/diagnosis-treatment-low-back-pain-joint-clinical-practice-guideline-from</a>.
        </td>
      </tr>
      <tr>
        <td>51.</td>
        <td>Hegmann K. Low back pain disorders. <a
            (click)="open(disclaimer, 'https://www.dir.ca.gov/dwc/ForumDocs/Implementing-AB-1124-Drug-Formularyand-update-of-MTUS-Guideline/Low-Back.pdf')">https://www.dir.ca.gov/dwc/ForumDocs/Implementing-AB-1124-Drug-Formularyand-update-of-MTUS-Guideline/Low-Back.pdf</a>
          (Access date 8 Nov 2017).</td>
      </tr>
      <tr>
        <td>52.</td>
        <td>Poitras P, Rossignol M, Dionne C et al. BMC Musculoskelet Dis. 9 54 (2008). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/18426590')">https://www.ncbi.nlm.nih.gov/pubmed/18426590</a>.
        </td>
      </tr>
      <tr>
        <td>53.</td>
        <td>Institute for Clinical Systems Improvement (Icsi). Adult acute and subacute low back pain. <a
            (click)="open(disclaimer, 'https://www.icsi.org/_asset/3v2nvw/lbp-03.18.pdf')">https://www.icsi.org/_asset/3v2nvw/lbp-03.18.pdf</a>
          (Access date 27 Nov 2018).</td>
      </tr>
      <tr>
        <td>54.</td>
        <td>Negrini S, Giovannoni S, Minozzi S et al. Eura Medicophys. 42(2), 151-70 (2006). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/16767064')">https://www.ncbi.nlm.nih.gov/pubmed/16767064</a>.
        </td>
      </tr>
      <tr>
        <td>55.</td>
        <td>Malaysian Association for the Study of Pain, Spine Society Malaysia. The Malaysian Low Back Pain Management
          Guidelines. <a
            (click)="open(disclaimer, 'http://www.masp.org.my/index.cfm?&menuid=23')">http://www.masp.org.my/index.cfm?&menuid=23</a>.
        </td>
      </tr>
      <tr>
        <td>56.</td>
        <td>Islamic Republic of Afghanistan, Ministry of Public Health, General Directorate of Pharmaceutical Affairs.
          National standard treatment guidelines for the primary level. <a
            (click)="open(disclaimer, 'http://apps.who.int/medicinedocs/documents/s21744en/s21744en.pdf')">http://apps.who.int/medicinedocs/documents/s21744en/s21744en.pdf</a>
          (Access date 13 Jul 2018).</td>
      </tr>
      <tr>
        <td>57.</td>
        <td>British Columbia Medical Association. Osteoarthritis in peripheral joints – diagnosis and treatment. <a
            (click)="open(disclaimer, 'http://www2.gov.bc.ca/gov/content/health/practitioner-professional-resources/bc-guidelines/osteoarthritis')">http://www2.gov.bc.ca/gov/content/health/practitioner-professional-resources/bc-guidelines/osteoarthritis</a>
          (Access date 28 Sep 2017).</td>
      </tr>
      <tr>
        <td>58.</td>
        <td>Kielly J, Davis E, Marra C. Can Pharm J (Ott). 150(3), 156-68 (2017). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5415069/')">https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5415069/</a>.
        </td>
      </tr>
      <tr>
        <td>59.</td>
        <td>Qiu G, Chinese Orthopaedic Association. Orthopaed Surg. 2(1), 1-6 (2010). <a
            (click)="open(disclaimer, 'https://onlinelibrary.wiley.com/doi/full/10.1111/j.1757-7861.2009.00055.x.')">https://onlinelibrary.wiley.com/doi/full/10.1111/j.1757-7861.2009.00055.x</a>.
        </td>
      </tr>
      <tr>
        <td>60.</td>
        <td>Drug Administration and Control Authority of Ethiopia. Standard Treatment Guidelines for Health Station -
          Ethiopia <a
            (click)="open(disclaimer, 'http://collections.infocollections.org/whocountry/fr/d/Js6858e/9.10.html ')">http://collections.infocollections.org/whocountry/fr/d/Js6858e/9.10.html</a>
          (Access date 20 Aug 2018).</td>
      </tr>
      <tr>
        <td>61.</td>
        <td>Bruyère O, Cooper C, Pelletier Jp et al. Semin Arthritis Rheum. 45(4 Suppl), S3-S11 (2016). <a
            (click)="open(disclaimer, 'http://www.sciencedirect.com/science/article/pii/S0049017215002887')">http://www.sciencedirect.com/science/article/pii/S0049017215002887</a>.
        </td>
      </tr>
      <tr>
        <td>62.</td>
        <td>Ministry of Health & Family Welfare Government of India. Standard treatment guidelines: Management of
          ostoarthritis knee. <a
            (click)="open(disclaimer, 'http://clinicalestablishments.gov.in/WriteReadData/31911.pdf ')">http://clinicalestablishments.gov.in/WriteReadData/31911.pdf</a>
          (Access date 20 Aug 2018).</td>
      </tr>
      <tr>
        <td>63.</td>
        <td>Ministry of Health Malaysia. Clinical Practice Guidelines. Management of osteoarthritis (second edition). <a
            (click)="open(disclaimer, 'http://www.acadmed.org.my/index.cfm?&menuid=67')">http://www.acadmed.org.my/index.cfm?&menuid=67</a>
          (Access date 28 September 2017).</td>
      </tr>
      <tr>
        <td>64.</td>
        <td>Best Practice Advocacy Centre New Zealand. Managing pain in osteoarthritis: focus on the person. <a
            (click)="open(disclaimer, 'https://bpac.org.nz/2018/osteoarthritis.aspx')">https://bpac.org.nz/2018/osteoarthritis.aspx</a>
          (Access date 18 Nov 2018).</td>
      </tr>
      <tr>
        <td>65.</td>
        <td>Philippine Rheumatology Association. Osteoarthritis. <a
            (click)="open(disclaimer, 'https://www.thefilipinodoctor.com/cpm_pdf/CPM12th%20Osteoarthritis.pdf')">https://www.thefilipinodoctor.com/cpm_pdf/CPM12th%20Osteoarthritis.pdf</a>
          (Access date 20 Aug 2018).</td>
      </tr>
      <tr>
        <td>66.</td>
        <td>Denisov L, Tsvetkova E, Golubev G, Et Al. Rheumatol Sci Pract. 54(6), 641-52 (2016). <a
            (click)="open(disclaimer, 'http://rsp.ima-press.net/rsp/article/viewFile/2317/1535')">http://rsp.ima-press.net/rsp/article/viewFile/2317/1535</a>.
        </td>
      </tr>
      <tr>
        <td>67.</td>
        <td>Ickinger C, Tikly M. SA Fam Pract. 52(5), 382-90 (2010). <a
            (click)="open(disclaimer, 'http://www.safpj.co.za/index.php/safpj/article/view/1637')">http://www.safpj.co.za/index.php/safpj/article/view/1637</a>.
        </td>
      </tr>
      <tr>
        <td>68.</td>
        <td>State Pharmaceuticals Corporation of Sri Lanka. The Sri Lanka Prescriber: Managing Osteoarthritis. <a
            (click)="open(disclaimer, 'http://www.spc.lk/prescriber/september2015.pdf')">http://www.spc.lk/prescriber/september2015.pdf</a>
          (Access date 20 Aug 2018).</td>
      </tr>
      <tr>
        <td>69.</td>
        <td>National Institute for Health and Care Excellence (Nice). Clinical Guidelines. (2014). <a
            (click)="open(disclaimer, 'www.nice.org.uk/guidance/cg177')">www.nice.org.uk/guidance/cg177</a>.</td>
      </tr>
      <tr>
        <td>70.</td>
        <td>Rillo O, Riera H, Acosta C, Et Al. J Clin Rheumatol. 22 345-54 (2016). <a
            (click)="open(disclaimer, 'https://pdfs.semanticscholar.org/dd79/23737a16b30b2da642d12ef92c596acc6aba.pdf')">https://pdfs.semanticscholar.org/dd79/23737a16b30b2da642d12ef92c596acc6aba.pdf</a>.
        </td>
      </tr>
      <tr>
        <td>71.</td>
        <td>National Health and Medical Research Council, Royal Australian College of General Practitioners. Guideline
          for the non-surgical management of hip and knee osteoarthritis. <a
            (click)="open(disclaimer, 'https://www.racgp.org.au/FSDEDEV/media/documents/Clinical%20Resources/Guidelines/Joint%20replacement/Guideline-for-the-management-of-knee-and-hip-OA-2nd-edition.pdf')">https://www.racgp.org.au/FSDEDEV/media/documents/Clinical%20Resources/Guidelines/Joint%20replacement/Guideline-for-the-management-of-knee-and-hip-OA-2nd-edition.pdf</a>
          (Access date 18 Nov 2018).</td>

      </tr>
      <tr>
        <td>72.</td>
        <td>Australian Commission on Safety and Quality in Health Care. Osteoarthritis of the Knee. Clinical Care
          Standard. <a
            (click)="open(disclaimer, 'https://www.safetyandquality.gov.au/wp-content/uploads/2017/05/Osteoarthritis-of-the-Knee-Clinical-Care-Standard-Booklet.pdf')">https://www.safetyandquality.gov.au/wp-content/uploads/2017/05/Osteoarthritis-of-the-Knee-Clinical-Care-Standard-Booklet.pdf</a>
          (Access date 18 Aug 2018).</td>

      </tr>
      <tr>
        <td>73.</td>
        <td>
          Federal Ministry of Health for Nigeria. Standard treatment guidelines. <a
            (click)="open(disclaimer, 'http://www.health.gov.ng/doc/FMOH%20-%20Nigeria%20Standard%20Treatment%20Guidelines%202nd%20Edition%20(2016).pdf')">
            http://www.health.gov.ng/doc/FMOH%20-%20Nigeria%20Standard%20Treatment%20Guidelines%202nd%20Edition%20(2016).pdf

          </a> (Access date 11 Dec 2018).
        </td>

      </tr>
      <tr>
        <td>74.</td>
        <td>Mcalindon Te, Bannuru Rr, Sullivan Mc et al. Osteoarthritis Cartilage. 22(3), 363-88 (2014). <a
            (click)="open(disclaimer, 'http://www.sciencedirect.com/science/article/pii/S1063458414000168')">http://www.sciencedirect.com/science/article/pii/S1063458414000168</a>.
        </td>

      </tr>
      <tr>
        <td>75.</td>
        <td>Hochberg Mc, Altman Rd, April Kt et al. Arthritis Care Res (Hoboken). 64(4), 465-74 (2012). <a
            (click)="open(disclaimer, 'http://onlinelibrary.wiley.com/doi/10.1002/acr.21596/full')">http://onlinelibrary.wiley.com/doi/10.1002/acr.21596/full</a>.
        </td>

      </tr>
      <tr>
        <td>76.</td>
        <td>Sinusas K. Am Fam Physician. 85(1), 49-56 (2012). <a
            (click)="open(disclaimer, 'http://www.aafp.org/afp/2012/0101/p49.html.')">http://www.aafp.org/afp/2012/0101/p49.html</a>.
        </td>

      </tr>
      <tr>
        <td>77.</td>
        <td>The Non-Surgical Management of Hip & Knee Osteoarthritis Working Group. VA/DoD Clinical practice guideline
          for the non-surgical management of hip & knee osteoarthritis. <a
            (click)="open(disclaimer, 'https://www.healthquality.va.gov/guidelines/CD/OA/')">https://www.healthquality.va.gov/guidelines/CD/OA/</a>
          (Access date 28 Sep 2017).</td>

      </tr>
      <tr>
        <td>78.</td>
        <td>Kloppenburg M, Kroon FPB, Blanco FJ, Et Al. Ann Rheum Dis. doi:10.1136/annrheumdis-2018-213826 (2018). <a
            (click)="open(disclaimer, 'https://ard.bmj.com/content/early/2018/08/27/annrheumdis-2018-213826')">https://ard.bmj.com/content/early/2018/08/27/annrheumdis-2018-213826</a>.
        </td>

      </tr>
      <tr>
        <td>79.</td>
        <td>
          Schug Sa, Palmer Gm, Scott Da, Halliwell R, Trinca J, Apm:Se Working Group of the Australian and New Zealand
          College of Anaesthetists and Faculty of Pain Medicine.
          Acute Pain Management: Scientific Evidence. (4th). ANZCA & FPM, Melbourne, Australia. (2015). <a
            (click)="open(disclaimer, '')"></a>
        </td>

      </tr>
      <tr>
        <td>80.</td>
        <td>
          Royal College of Dental Surgeons of Ontario. The role of opioids in the management of acute and chronic pain
          in dental practice. <a
            (click)="open(disclaimer, 'https://az184419.vo.msecnd.net/rcdso/pdf/guidelines/RCDSO_Guidelines_Role_of_Opioids.pdf')">
            https://az184419.vo.msecnd.net/rcdso/pdf/guidelines/RCDSO_Guidelines_Role_of_Opioids.pdf
          </a> (Access date 17 Dec 2018).
        </td>

      </tr>
      <tr>
        <td>81.</td>
        <td>French-Speaking Society of Oral Medicine and Oral Surgery. Médecine Buccale Chirurgie Buccale. 14(3),
          (2008). <a
            (click)="open(disclaimer, 'http://societechirorale.com/documents/Recommandations/recommandations_anti-inflammatoires-EN.pdf')">http://societechirorale.com/documents/Recommandations/recommandations_anti-inflammatoires-EN.pdf</a>.
        </td>

      </tr>
      <tr>
        <td>82.</td>
        <td>Hargreaves K. Successful management of acute pain. <a
            (click)="open(disclaimer, 'http://www.orofacialpain.org.uk/downloads/acute/Summary%20paper%20HargreavesSummitV.pdf')">http://www.orofacialpain.org.uk/downloads/acute/Summary%20paper%20HargreavesSummitV.pdf</a>
          (Access date 4 Jan 2018).</td>

      </tr>
      <tr>
        <td>83.</td>
        <td>
          Malaysia Ministry of Health, Pain Free Hospital. Guidelines for pain management in emergency and trauma
          department. <a
            (click)="open(disclaimer, 'http://www.moh.gov.my/index.php/file_manager/dl_item/554756755a584a69615852686269394962334e7761585268624342435a574a686379424c5a584e6861326c3059573476516d466f59573467554756755a476c6b615774686269395159576c7558303168626d466e5a57316c626e5266615735665257316c636d646c626d4e355831527959585674595639455a584268636e52745a5735304c6e426b5a673d3d')">
            http://www.moh.gov.my/index.php/file_manager/dl_item/554756755a584a69615852686269394962334e7761585268624342435a574a686379424c5a584e6861326c3059573476516d466f59573467554756755a476c6b615774686269395159576c7558303168626d466e5a57316c626e5266615735665257316c636d646c626d4e355831527959585674595639455a584268636e52745a5735304c6e426b5a673d3d
          </a> (Access date 4 Jan 2018).
        </td>

      </tr>
      <tr>
        <td>84.</td>
        <td>Wänman A, Ernberg M, List T. Nor Tannlegeforen Tid. 126 104-12 (2016). <a
            (click)="open(disclaimer, 'http://www.tannlegetidende.no/i/2016/2/d2e661')">http://www.tannlegetidende.no/i/2016/2/d2e661</a>.
        </td>

      </tr>
      <tr>
        <td>85.</td>
        <td>Scottish Dental Clinical Effectiveness Programme. Drug prescribing for dentistry. Dental clinical
          guidelines. <a
            (click)="open(disclaimer, 'http://www.sdcep.org.uk/wp-content/uploads/2016/03/SDCEP-Drug-Prescribing-for-Dentistry-3rd-edition.pdf')">http://www.sdcep.org.uk/wp-content/uploads/2016/03/SDCEP-Drug-Prescribing-for-Dentistry-3rd-edition.pdf</a>
          (Access date 4 Jan 2018).</td>

      </tr>
      <tr>
        <td>86.</td>
        <td>American Association of Endodontists. A "3D" approach for treating acute pain. <a
            (click)="open(disclaimer, 'https://www.aae.org/specialty/wp-content/uploads/sites/2/2017/07/ecfeacutedentalpain.pdf')">https://www.aae.org/specialty/wp-content/uploads/sites/2/2017/07/ecfeacutedentalpain.pdf</a>
          (Access date 3 Sep 2018).</td>

      </tr>
      <tr>
        <td>87.</td>
        <td>Thorson D, Biewen P, Bonte B et al. Acute pain assessment and opioid prescribing protocol. Institute for
          Clinical Systems Improvement. <a
            (click)="open(disclaimer, 'https://crh.arizona.edu/sites/default/files/u35/Opioids.pdf')">https://crh.arizona.edu/sites/default/files/u35/Opioids.pdf</a>
          (Access date 4 Jan 2018).</td>

      </tr>
      <tr>
        <td>88.</td>
        <td>Minnesota Dental Association. MDA Protocol for Assessment and Treatment of Oral/ Facial Pain. <a
            (click)="open(disclaimer, 'https://www.mndental.org/files/Acute-Orofacial-Pain-Assessment-and-Opioid-Prescribing-Protocol.pdf')">https://www.mndental.org/files/Acute-Orofacial-Pain-Assessment-and-Opioid-Prescribing-Protocol.pdf
          </a> (Access date 21 Nov 2018).</td>

      </tr>
      <tr>
        <td>89.</td>
        <td>Alaska Dental Association. For safe prescribing of opioids and non-opiate alternatives. <a
            (click)="open(disclaimer, 'https://www.akdental.org/docs/librariesprovider9/opioid/11-18-ads-opioid-amp-nonopioid-alternative-prescribing-guideline.pdf')">https://www.akdental.org/docs/librariesprovider9/opioid/11-18-ads-opioid-amp-nonopioid-alternative-prescribing-guideline.pdf</a>
          (Access date 21 Nov 2018).</td>

      <tr>
        <td>90.</td>
        <td>Pennsylvania Dental Association. Pennsylvania guidelines on the use of opioids in dental practice. <a
            (click)="open(disclaimer, 'https://www.padental.org/Images/OnlineDocs/ResourcesPrograms/Practice%20Management/opioid_dental_prescribing_guidelines3_13_15.pdf')">https://www.padental.org/Images/OnlineDocs/ResourcesPrograms/Practice%20Management/opioid_dental_prescribing_guidelines3_13_15.pdf</a>
          (Access date 21 Nov 2018).</td>

      </tr>
      <tr>
        <td>91.</td>
        <td>Analgesia Management Working Group. Recommendations for prescribing analgesia on discharge following surgery
          or acute injury. Information for health practitioners preparing the patient for discharge. <a
            (click)="open(disclaimer, 'http://ww2.health.wa.gov.au/~/media/Files/Corporate/general%20documents/WATAG/Analgesia-Discharge-After-Surgery-or-Injury.pdf')">http://ww2.health.wa.gov.au/~/media/Files/Corporate/general%20documents/WATAG/Analgesia-Discharge-After-Surgery-or-Injury.pdf</a>
          (Access date 4 Jul 2018).</td>

      </tr>
      <tr>
        <td>92.</td>
        <td>Savoia G, Alampi D, Amantea B, Et Al. Minerva Anestesiologica. 76(8), 657-67 (2010). <a
            (click)="open(disclaimer, 'https://www.minervamedica.it/en/journals/minerva-anestesiologica/article.php?cod=R02Y2010N08A0657')">https://www.minervamedica.it/en/journals/minerva-anestesiologica/article.php?cod=R02Y2010N08A0657</a>.
        </td>

      </tr>
      <tr>
        <td>93.</td>
        <td>South African Society of Anaesthesiologists. South African Acute Pain Guidelines. Official publication of
          The South African Society of Anaesthesiologists (SASA). <a
            (click)="open(disclaimer, 'https://painsa.org.za/wp-content/uploads/2016/07/SASA-Acute-Pain-Guidelines_2015.pdf')">https://painsa.org.za/wp-content/uploads/2016/07/SASA-Acute-Pain-Guidelines_2015.pdf</a>
          (Access date 4 Jul 2018).</td>

      </tr>
      <tr>
        <td>94.</td>
        <td>Chou R, Gordon D, De Leon-Casasola O, Et Al. J Pain. 17(2), 131-57 (2016). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pubmed/26827847')">https://www.ncbi.nlm.nih.gov/pubmed/26827847</a>.
        </td>

      </tr>
      <tr>
        <td>95.</td>
        <td>American Association of Oral and Maxillofacial Surgeons. Opioid Prescribing: Acute and Postoperative Pain
          Management. <a
            (click)="open(disclaimer, 'https://www.aaoms.org/docs/govt_aairs/advocacy_white_papers/opioid_prescribing.pdf')">https://www.aaoms.org/docs/govt_affairs/advocacy_white_papers/opioid_prescribing.pdf
          </a> (Access date 4 Jul 2018).</td>

      </tr>
      <tr>
        <td>96.</td>
        <td>Rawal N, De Andres J, Fischer H, Et Al. Postoperative Pain Management - Good Clinical Practice. <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4745947/pdf/jpr-9-025.pdf')">https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4745947/pdf/jpr-9-025.pdf
          </a> (Access date 30 Nov 2017).</td>

      </tr>
      <tr>
        <td>97.</td>
        <td>Prospect. Procedure specific postoperative pain management. <a
            (click)="open(disclaimer, 'http://www.postoppain.org/')">http://www.postoppain.org/ </a> (Access date 30 Nov
          2017).</td>

      </tr>
      <tr>
        <td>98.</td>
        <td>
          Sfar Committees on Pain and Local Regional Anaesthesia and on Standards. Annales Françaises d’Anesthésie et de
          Réanimation. 28 403-9 (2009). <a
            (click)="open(disclaimer, 'http://sfar.org/wp-content/uploads/2015/09/2b_AFAR_ANGLAISEExpert-panel-guidelines-2008.-Postoperative-painmanagement-in-adults-and-children.-SFAR-Committees-on-Pain-and-Local-Regional-Anaesthesia-and-on-Standards..pdf')">
            http://sfar.org/wp-content/uploads/2015/09/2b_AFAR_ANGLAISEExpert-panel-guidelines-2008.-Postoperative-painmanagement-in-adults-and-children.-SFAR-Committees-on-Pain-and-Local-Regional-Anaesthesia-and-on-Standards..pdf.
          </a>
        </td>

      </tr>
      <tr>
        <td>99.</td>
        <td>
          Korean Knee Society. Knee Surg Relat Res. 24(4), 201-7 (2012). <a
            (click)="open(disclaimer, 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3526756/')">
            https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3526756/</a>.
        </td>

      </tr>
      <tr>
        <td>100.</td>
        <td>
          Ministry of Health Malaysia. Pain management handbook. <a
            (click)="open(disclaimer, 'http://www.moh.gov.my/english.php/pages/view/580')">
            http://www.moh.gov.my/english.php/pages/view/580</a> (Access date 4 Jul 2018).
        </td>

      </tr>
      <tr>
        <td>101.</td>
        <td>
          Misiołek H, Zajaczkowska R, Daszkiewicz A et al. Anaesthesiol Intensive Ther 50(4), 173-99 (2018). <a
            (click)="open(disclaimer, 'https://journals.viamedica.pl/anaesthesiology_intensivetherapy/article/view/AIT.2018.0026/45188')">
            https://journals.viamedica.pl/anaesthesiology_intensivetherapy/article/view/AIT.2018.0026/45188</a>.
        </td>

      </tr>
      <tr>
        <td>102.</td>
        <td>
          Sri Lanka College of Obstetricians & Gynaecologists. Management of acute pain. <a
            (click)="open(disclaimer, 'http://www.slcog.lk/other-national-guidelines.php')">
            http://www.slcog.lk/other-national-guidelines.php
          </a> (Access date 4 Jul 2018).
        </td>

      </tr>
      <tr>
        <td>103.</td>
        <td>
          American Society of Perianesthesia Nurses. ASPAN pain and comfort clinical guideline. <a
            (click)="open(disclaimer, 'http://www.aspan.org/Home/Search-Results?search=pain%20and%20comfort&scope=Pages')">
            http://www.aspan.org/Home/Search-Results?search=pain%20and%20comfort&scope=Pages
          </a> (Access date 16 Dec 2018).
        </td>

      </tr>
      <tr>
        <td>104.</td>
        <td>
          Paez Borda A, Charnay-Sonnek F, Fonteyne V, Papaioannou E. Guidelines on pain management & palliative care. <a
            (click)="open(disclaimer, 'http://uroweb.org/wp-content/uploads/25-Pain-Management_LR.pdf')">
            http://uroweb.org/wp-content/uploads/25-Pain-Management_LR.pdf
          </a> (Access date 18 Nov 2018).
        </td>

      </tr>







    </table>
  </div>
</div>

<ng-template #disclaimer let-modal>
  <div class="modal-header">
    <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
      id="GhoshTitle">
      <strong>
        Disclaimer
      </strong>
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true"><img src="assets/images/close.png"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">
      <div class="row" style="padding-top: 20px;">
        <div class="col-lg-12 col-md-12 col-sm-12 disclaimer-content">
          <p>
            You are now leaving the &lt;sitename&gt;, and are being connected to a third party web site. Please note
            that &lt;sitename&gt; is not responsible for the information, content or product(s) found on third party web
            sites.


          </p>
          <p>
            By accessing the noted link you will be leaving our website and entering a website hosted by another party.
            Please be advised that you will no longer be subject to, or under the protection of, our privacy and
            security policies. We encourage you to read and evaluate the privacy and security policies of the site you
            are entering, which may be different than ours.
          </p>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer" style="text-align:right !important;">
    <button type="button" class="btn btn-primary ok-btn" data-dismiss="modal" aria-label="Close"
      (click)="modal.dismiss('ok')">
      <span aria-hidden="true">OK</span>
    </button>
  </div>
</ng-template>
